module.exports = __webpack_public_path__ + "static/media/1.fdf746ca.jpg";